import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Bookmarks from './Bookmarks/index.js';
import * as serviceWorker from './serviceWorker';

ReactDOM.render(<Bookmarks />, document.getElementById('root'));
serviceWorker.register();
